import React, { useContext } from "react";

//material UI
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import CardActions from "@material-ui/core/CardActions";

//components
import ClusterRowInfoMobileConnect from "./ClusterRowInfoMobileConnect";

//global state
import { StateContext } from "../../AppStateContext";

const ClusterRowMobileInfoHTMLContentActions = ({
  classes,
  openDeleteModal,
  clusterInfo,
}) => {
  //consume global state
  const state = useContext(StateContext);

  return (
    <CardActions className={classes.actions}>
      <ClusterRowInfoMobileConnect clusterInfo={clusterInfo} />
      <DeleteForeverIcon
        id="deleteClusterIcon"
        onClick={openDeleteModal}
        style={{
          color: state.theme === "dark" ? "#fff" : "#fa0171",
          cursor: "pointer",
          width: "50px",
        }}
      />
    </CardActions>
  );
};

export default ClusterRowMobileInfoHTMLContentActions;
